import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { okResponse } from '../../routes/defaultResponses';
import { makeNullable } from '../../utils/typeboxHelpers';
import { sortColumnsSchema } from '../sortColumnsSchema';

export const objectTypePaths = {
    '/api/objectTypes/': {
        get: {
            operationId: 'objectTypeControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                total: Type.Number(),
                                items: Type.Array(
                                    Type.Intersect([
                                        Type.Object({
                                            id: Type.String(),
                                        }),
                                        Type.Object({
                                            name: Type.String(),
                                        }),
                                        Type.Object({
                                            status: Type.String(),
                                        }),
                                        Type.Object({
                                            language: Type.Object({
                                                name: Type.String(),
                                            }),
                                        }),
                                        Type.Object({
                                            language: Type.Object({
                                                code: Type.String(),
                                            }),
                                        }),
                                        Type.Object({
                                            clientCompany: Type.Object({
                                                name: Type.String(),
                                            }),
                                        }),
                                    ]),
                                ),
                            }),
                        },
                    },
                },
            },
            parameters: [
                { name: 'status', in: 'query', schema: Type.String() },
                { name: 'limit', in: 'query', schema: Type.String(), required: true },
                { name: 'offset', in: 'query', schema: Type.String(), required: true },
                { name: 'sortColumns', in: 'query', schema: sortColumnsSchema, required: true },
            ],
        },
    },
    '/api/objectTypes/{objectTypeId}': {
        parameters: [createPathGuidParameter('objectTypeId')],
        get: {
            operationId: 'objectTypeControllers.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Optional(
                                Type.Intersect([
                                    Type.Object({
                                        id: Type.String(),
                                    }),
                                    Type.Object({
                                        name: Type.String(),
                                    }),
                                    Type.Object({
                                        languageId: Type.String(),
                                    }),
                                    Type.Object({
                                        clientCompanyId: makeNullable(Type.String()),
                                    }),
                                    Type.Object({
                                        status: Type.String(),
                                    }),
                                ]),
                            ),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'objectTypeControllers.update',
            responses: {
                ...okResponse,
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            name: Type.String(),
                            languageId: Type.String(),
                            status: Type.String(),
                            clientCompanyId: makeNullable(Type.String()),
                        }),
                    },
                },
            },
        },
        delete: {
            operationId: 'objectTypeControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/objectTypesList/': {
        get: {
            operationId: 'objectTypeControllers.getList',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Intersect([
                                    Type.Object({
                                        name: Type.String(),
                                    }),
                                    Type.Object({
                                        id: Type.String(),
                                    }),
                                ]),
                            ),
                        },
                    },
                },
            },
            parameters: [
                { name: 'languageCode', in: 'query', schema: Type.String() },
                { name: 'clientCompanyId', in: 'query', schema: Type.String() },
            ],
        },
    },
    '/api/objectTypes': {
        post: {
            operationId: 'objectTypeControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            createNenInspectionStandard: Type.Boolean(),
                            name: Type.String(),
                            languageId: Type.String(),
                            clientCompanyId: Type.Optional(Type.String()),
                            status: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
} as const;
